import Box from '@mui/material/Box';
import List from '@mui/material/List';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemText from '@mui/material/ListItemText';
import Paper from '@mui/material/Paper';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import { NavLink, Outlet, useLocation } from 'react-router-dom';

/**
 * Help section shell. Left rail of topic links + the active topic's
 * content on the right. Topics live as sibling components so they
 * can grow independently; this layout just routes between them.
 */

const TOPICS = [
  { to: '/help', label: 'Getting started', end: true },
  { to: '/help/faq', label: 'FAQ' },
  { to: '/help/release-notes', label: "What's new" },
];

export function HelpLayout() {
  const { pathname } = useLocation();

  return (
    <Stack spacing={3}>
      <Typography variant="h4">Help</Typography>
      <Box sx={{ display: 'flex', gap: 3, flexDirection: { xs: 'column', md: 'row' } }}>
        <Paper sx={{ width: { md: 240 }, flexShrink: 0 }}>
          <List dense>
            {TOPICS.map((t) => {
              const active = t.end
                ? pathname === t.to
                : pathname === t.to || pathname.startsWith(t.to + '/');
              return (
                <ListItemButton
                  key={t.to}
                  component={NavLink}
                  to={t.to}
                  selected={active}
                  end={t.end}
                >
                  <ListItemText primary={t.label} />
                </ListItemButton>
              );
            })}
          </List>
        </Paper>
        <Box sx={{ flexGrow: 1, minWidth: 0 }}>
          <Outlet />
        </Box>
      </Box>
    </Stack>
  );
}
